import BillDateTitleWithTimezone from "@/common/components/BillDateTitleWithTImezone";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import useCompany from "@/common/hooks/queries/useCompany";
import BillHeaderDropdownActions from "@/features/billingBills/components/HeaderDropdownActions";
import useBillingBill from "@/features/billingBills/hooks/useBillingBill";
import BillingBillsShow from "@/features/billingBills/pages/Show";
import { useCompanyGovernmentAllocation } from "@/features/privateCompanies/hooks/useCompanyGovernmentAllocation";
import { useParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";

const GovernmentAllocationBillShow = () => {
const { companyId, governmentAllocationId, billId } = useParams();

  const {
    data: company,
    isPending: companyIsPending,
  } = useCompany({ id: companyId || '' });

  const {
    data: governmentAllocation,
    isPending: governmentAllocationIsPending,
  } = useCompanyGovernmentAllocation(governmentAllocationId || '');

  const {
    data: bill,
    error: billError = {} as any,
    refetch: refetchBill,
  } = useBillingBill({ id: billId });

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={billError?.status}
      refetchFunction={refetchBill}
      notFoundFallback={`/companies/${companyId}/government-allocations/${governmentAllocationId}/bills`}
      notFoundButtonText='Ir para Faturas do Empenho'
    >
      <div>
        <ShowHeader
          goBack
          goBackProps={{
            fallback: `/companies/${companyId}/government-allocations/${governmentAllocationId}/bills`,
            searchLastRouteFromFallback: true,
          }}
          isLoading={companyIsPending || governmentAllocationIsPending}
          title={
            <div className='flex flex-col'>
              <p data-tooltip-id='branch-tooltip' className="text-nowrap max-w-72 overflow-hidden text-ellipsis font-normal">
                {company?.general_information?.fantasy_name}
              </p>

              <Tooltip id="branch-tooltip" place="top-start">
                <div className='flex flex-col'>
                  <p>
                    {company?.general_information?.fantasy_name}
                  </p>

                  <p className="font-light text-sm italic">
                    {governmentAllocation?.branch_display_name}
                  </p>
                </div>
              </Tooltip>
            </div>
          }
          titleClassName="text-md"
          subtitle={(
            <div className='flex items-center gap-1'>
              <p>
                Fatura {bill?.number}
              </p>

              <BillDateTitleWithTimezone
                startDate={bill?.opened_at}
                endDate={bill?.closed_at}
                timezone={bill?.time_zone}
              />
            </div>
          )}
          subtitleClassName="text-nowrap font-medium"
          buttons={<BillHeaderDropdownActions bill={bill} />}
        />

        <BillingBillsShow billType="client_bills" needSupplyAuthorization={bill?.need_supply_authorization} />
      </div>
    </ErrorMessageWrapper>
  );
};

export default GovernmentAllocationBillShow;
